import {
  PostEditorBitly,
  PostEditorPostError,
  PostEditorPostErrors,
  PostGroupsType
} from '../../../models/post-editor';
import { ErrorMessageSeverity } from '../../../constants/form';
import { PostEditorValidationMessages } from '../constants/validation-messages';
import { severityResolver } from './helpers/severity-resolver';
import { SingularValidator } from './helpers/singular-validator';

export const googleTextCharLimit = (
  postGroup: PostGroupsType,
  severity: ErrorMessageSeverity
): PostEditorPostErrors => {
  const { customizeContentPerProfile, profiles, bitlyAccount, categoryId } = postGroup;
  const { defaultBitly, profilesWithBitly } = bitlyAccount;
  let results: PostEditorPostError[] = [];
  if (customizeContentPerProfile) {
    postGroup.posts.forEach(post => {
      const { texts, link } = post.content;

      const selectedSocialProfiles = profiles.filter(
        p => p.__typename === 'GoogleSocialProfile' && p.profileId === post.customizedProfileId
      );
      const mappedBitly = profilesWithBitly.find(
        p => p.__typename === 'GoogleSocialProfile' && p.id === post.customizedProfileId
      );
      if (!mappedBitly || !selectedSocialProfiles.length) return;
      const errors = texts.flatMap(text =>
        SingularValidator.googleTextCharLimitInvalid(text, link, mappedBitly, defaultBitly, categoryId)
          ? {
              profileId: post.customizedProfileId,
              variationId: text.id,
              severity: severityResolver(postGroup.groupPostAttributes, severity),
              selectedSocialProfiles,
              message: PostEditorValidationMessages.googleTextCharLimit
            }
          : []
      );
      results = [...results, ...errors];
    });
  } else {
    const { texts, link } = postGroup.groupPostAttributes.content;
    const selectedSocialProfiles = profiles.filter(p => p.__typename === 'GoogleSocialProfile');
    const mappedBitly = profilesWithBitly
      .filter(p => p.__typename === 'GoogleSocialProfile')
      .reduce<PostEditorBitly['profilesWithBitly'][number] | null>((prev, current) => {
        if (!prev) return current;
        return current.displayName.length > prev.displayName.length ? current : prev;
      }, null); // in shared mode we need to find the profile with the longest name to get the max link length
    if (!mappedBitly || !selectedSocialProfiles.length) return false;

    const errors = texts.flatMap(text =>
      SingularValidator.googleTextCharLimitInvalid(text, link, mappedBitly, defaultBitly, categoryId)
        ? {
            profileId: null,
            variationId: text.id,
            severity: severityResolver(postGroup.groupPostAttributes, severity),
            selectedSocialProfiles,
            message: PostEditorValidationMessages.googleTextCharLimit
          }
        : []
    );
    results = [...results, ...errors];
  }
  return results.length ? results : false;
};
